/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineServiceKindDto } from './traveline-service-kind-dto';
import {
    TravelineServiceKindDtoFromJSON,
    TravelineServiceKindDtoFromJSONTyped,
    TravelineServiceKindDtoToJSON,
    TravelineServiceKindDtoToJSONTyped,
} from './traveline-service-kind-dto';
import type { TravelineVatDto } from './traveline-vat-dto';
import {
    TravelineVatDtoFromJSON,
    TravelineVatDtoFromJSONTyped,
    TravelineVatDtoToJSON,
    TravelineVatDtoToJSONTyped,
} from './traveline-vat-dto';
import type { TravelineServiceTotalDto } from './traveline-service-total-dto';
import {
    TravelineServiceTotalDtoFromJSON,
    TravelineServiceTotalDtoFromJSONTyped,
    TravelineServiceTotalDtoToJSON,
    TravelineServiceTotalDtoToJSONTyped,
} from './traveline-service-total-dto';

/**
 * Extra service
 * @export
 * @interface TravelineRoomStayServiceRsDto
 */
export interface TravelineRoomStayServiceRsDto {
    /**
     * Service ID
     * @type {string}
     * @memberof TravelineRoomStayServiceRsDto
     */
    id: string;
    /**
     * Number of extra services<br />
     * This parameter is used for "PerStay", "PerPerson", and "PerUse" charge types.
     * @type {number}
     * @memberof TravelineRoomStayServiceRsDto
     */
    quantity?: number | null;
    /**
     * Name
     * @type {string}
     * @memberof TravelineRoomStayServiceRsDto
     */
    name: string;
    /**
     * Description
     * @type {string}
     * @memberof TravelineRoomStayServiceRsDto
     */
    description: string;
    /**
     * Total for services<br />
     * @type {number}
     * @memberof TravelineRoomStayServiceRsDto
     */
    totalPrice?: number | null;
    /**
     * 
     * @type {TravelineServiceTotalDto}
     * @memberof TravelineRoomStayServiceRsDto
     */
    serviceTotal?: TravelineServiceTotalDto;
    /**
     * This parameter shows if the extra service is included in the rate plan.<br />
     * If the service is not included in the rate plan (inclusive = false), the TotalPrice is not specified
     * @type {boolean}
     * @memberof TravelineRoomStayServiceRsDto
     */
    inclusive: boolean;
    /**
     * 
     * @type {TravelineServiceKindDto}
     * @memberof TravelineRoomStayServiceRsDto
     */
    kind: TravelineServiceKindDto;
    /**
     * Meal plan code<br />
     * Displayed only if the service type is ‘Meal\’ (kind = Meal)
     * @type {string}
     * @memberof TravelineRoomStayServiceRsDto
     */
    mealPlanCode?: string | null;
    /**
     * Meal plan name<br />
     * Displayed only if the service type is ‘Meal\’ (kind = Meal)
     * @type {string}
     * @memberof TravelineRoomStayServiceRsDto
     */
    mealPlanName?: string | null;
    /**
     * 
     * @type {TravelineVatDto}
     * @memberof TravelineRoomStayServiceRsDto
     */
    vat?: TravelineVatDto;
}



/**
 * Check if a given object implements the TravelineRoomStayServiceRsDto interface.
 */
export function instanceOfTravelineRoomStayServiceRsDto(value: object): value is TravelineRoomStayServiceRsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('inclusive' in value) || value['inclusive'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function TravelineRoomStayServiceRsDtoFromJSON(json: any): TravelineRoomStayServiceRsDto {
    return TravelineRoomStayServiceRsDtoFromJSONTyped(json, false);
}

export function TravelineRoomStayServiceRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRoomStayServiceRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'name': json['name'],
        'description': json['description'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'serviceTotal': json['serviceTotal'] == null ? undefined : TravelineServiceTotalDtoFromJSON(json['serviceTotal']),
        'inclusive': json['inclusive'],
        'kind': TravelineServiceKindDtoFromJSON(json['kind']),
        'mealPlanCode': json['mealPlanCode'] == null ? undefined : json['mealPlanCode'],
        'mealPlanName': json['mealPlanName'] == null ? undefined : json['mealPlanName'],
        'vat': json['vat'] == null ? undefined : TravelineVatDtoFromJSON(json['vat']),
    };
}

  export function TravelineRoomStayServiceRsDtoToJSON(json: any): TravelineRoomStayServiceRsDto {
      return TravelineRoomStayServiceRsDtoToJSONTyped(json, false);
  }

  export function TravelineRoomStayServiceRsDtoToJSONTyped(value?: TravelineRoomStayServiceRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'quantity': value['quantity'],
        'name': value['name'],
        'description': value['description'],
        'totalPrice': value['totalPrice'],
        'serviceTotal': TravelineServiceTotalDtoToJSON(value['serviceTotal']),
        'inclusive': value['inclusive'],
        'kind': TravelineServiceKindDtoToJSON(value['kind']),
        'mealPlanCode': value['mealPlanCode'],
        'mealPlanName': value['mealPlanName'],
        'vat': TravelineVatDtoToJSON(value['vat']),
    };
}

